import { createContext, useContext } from 'react';

export type FooterConfig = {
	shouldResubmit: boolean;
	isValid: boolean;
	isDirty: boolean;
	isLoading?: boolean;
	onCancel?: () => void;
	onSubmit?: () => void | Promise<void>;
	isEnabled?: boolean;
	isBackNavigationEnabled?: boolean;
};

export interface FooterContextState {
	config?: FooterConfig;
	setConfig: (config?: FooterConfig) => void;
}

export const FooterContext = createContext<FooterContextState | null>(null);

export const useFooterConfig = () => {
	const context = useContext(FooterContext);
	if (!context) {
		throw new Error('useFooterConfig must be used within a FooterContextProvider');
	}
	return context;
};
